import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=1425f024"
import script from "./pieChart.vue?vue&type=script&lang=js"
export * from "./pieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1425f024')) {
      api.createRecord('1425f024', component.options)
    } else {
      api.reload('1425f024', component.options)
    }
    module.hot.accept("./pieChart.vue?vue&type=template&id=1425f024", function () {
      api.rerender('1425f024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/pieChart.vue"
export default component.exports